import React,{useEffect, useRef, useState} from 'react'
import { useTranslation } from "react-i18next"
import { Row, Col, Form, Button, Card, InputGroup, OverlayTrigger,Tooltip, Modal, Table, Dropdown, Container, useAccordionButton, Accordion } from 'react-bootstrap'
import Select from "react-select"
import Slider from "rc-slider"
import "rc-slider/assets/index.css"
import questions from '../../../components/questions.json'
import languages from "../../../components/languages.json"
import competences from '../../../components/competences.json'
import methodologies from '../../../components/methodologies.json'
import technologies from '../../../components/technologies.json'
import Swal from 'sweetalert2'
import softwares from '../../softwares'
import ecosystems from '../../ecosystem'
import { Link } from 'react-router-dom'
import provinces from '../../../components/provinces.json'
import towns from '../../../components/towns.json'
import { Doughnut } from 'react-chartjs-2'
import { registerChartPlugins } from '../../../hooks/ChartJSHook'

export default function SelectionForm({
        state,setState,levelSelect,subjectsSelect,
        handleSelectLinesChange,handleSelectSubjectsChange,
        generateDescription = () => {}, submit,
        isAdmin, schoolStaffs, school,
        isMultiSchool, schoolsOptions,
        maxScore,
        loading, IALoading
    }){
    const { t } = useTranslation()
    const translatedQuestions = questions.map((option) => ({
        value: option.value,
        label: t(option.label),
    }))

    registerChartPlugins() // Inicializa los plugins de Chart.js
    const ChartJsOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                    const dataset = tooltipItem.dataset;
                    const currentValue = dataset.data[tooltipItem.dataIndex];
                    const total = dataset.data.reduce((acc, val) => acc + val, 0);
                    const percentage = ((currentValue / total) * 100).toFixed(2); // Calcula el porcentaje
                    return ` ${percentage}%`; // Retorna el texto del tooltip
                    },
                },
            },
            centerText: {}
        },
    }

    const handleSchoolChange = (value) => {
        setState({
            ...state,
            school: value
        })
    }

    const handleSelectQuestionsChange = (e,type) =>{
        setState({
            ...state,
            questions: {...state.questions, [type]: e.label}
        })
    }

    const [reasons, setReasons] = useState({
        options: [
            {label: t('selection.reasons.maternity'), value: 'maternity'},
            {label: t('selection.reasons.epidemic'), value: 'epidemic'},
            {label: t('selection.reasons.others'), value: 'others'}
        ],
        selected: {}
    })

    useEffect(() => {
        if(state?.reasonReplacement){
            setReasons({
                ...reasons,
                selected: reasons.options?.find(reason => reason.value === state.reasonReplacement)
            })
        }
    // eslint-disable-next-line
    },[state])

    const handleReasonsChange = (target) => {
        setReasons({
            ...reasons,
            selected: target
        })
        setState({
            ...state,
            'reasonReplacement': target.value
        })
    }

    const handleDateChange = ({target})=>{
        const date = new Date(target.value)
        const today = new Date()
        const diffTime = Math.abs(date - today)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        const startDate = diffDays < 30 ? today : new Date(date - 30 * 24 * 60 * 60 * 1000)
        const formattedStartDate = startDate.toISOString().split('T')[0]
        setState({
            ...state,
            [target.name]: target.value,
            startDate: formattedStartDate
        })
    }

    const handleInputChange = ({target})=>{
        setState({
            ...state,
            [target.name]: target.value
        })
    }

    const handleInputQuestionChange = ({target})=>{
        setState({
            ...state,
            questions: {...state.questions, [target.name]: target.value}
        })
    }

    const handleInputWeightChange = ({target})=>{
        setState({
            ...state,
            requirementWeighting: {...state.requirementWeighting, [target.name]: target.value}
        })
    }

    const handleSwitchChange = (value,type) => {
        if (type === "contractType") {
            setState({
                ...state,
                [type]: value,
                fixedDiscontinuous: false
            })
        } else {
            setState({
                ...state,
                [type]: value,
            })
        }
    }

    const handleSliderChange = (low, high) => {
        setState({
            ...state,
            ageRange:{
                min: low,
                max: high
            }
        })
    }

    // IDIOMAS
    const [languageOptions, setLanguageOptions] = useState([])
    const [languageSelectedPrimaries, setLanguageSelectedPrimaries] = useState([])
    const [languageSelectedSecondaries, setLanguageSelectedSecondaries] = useState([])
    useEffect(() => {
        let primaryValuesToState = languageSelectedPrimaries?.map(option => ({id: option.value, weighting: 'primary'}))
        let secondaryValuesToState = languageSelectedSecondaries?.map(option => ({id: option.value, weighting: 'secondary'}))

        setState({
            ...state,
            requirements: {
                ...state.requirements,
                language: [...primaryValuesToState, ...secondaryValuesToState]
            }
        })

        const primaryValues = languageSelectedPrimaries?.map(option => option.value)
        const secondaryValues = languageSelectedSecondaries?.map(option => option.value)
        const options = languages.filter(language => !primaryValues.includes(language.language) && !secondaryValues.includes(language.language))
            .map(language => ({ value: language.language, label: language.language }))
        setLanguageOptions(options)
    // eslint-disable-next-line
    }, [languages, languageSelectedPrimaries, languageSelectedSecondaries])

    // COMPETENCIAS
    const [competenceOptions, setCompetenceOptions] = useState([])
    const [competenceSelectedPrimaries, setCompetenceSelectedPrimaries] = useState([])
    const [competenceSelectedSecondaries, setCompetenceSelectedSecondaries] = useState([])
    useEffect(() => {
        let primaryValuesToState = competenceSelectedPrimaries?.map(option => ({id: option.value, weighting: 'primary'}))
        let secondaryValuesToState = competenceSelectedSecondaries?.map(option => ({id: option.value, weighting: 'secondary'}))

        setState({
            ...state,
            requirements: {
                ...state.requirements,
                competences: [...primaryValuesToState, ...secondaryValuesToState]
            }
        })

        const primaryValues = competenceSelectedPrimaries?.map(option => option.value)
        const secondaryValues = competenceSelectedSecondaries?.map(option => option.value)
        const options = competences.filter(competence => !primaryValues.includes(competence.id) && !secondaryValues.includes(competence.id))
            .map(competence => ({ value: competence.id, label: competence.name }))
        setCompetenceOptions(options)
    // eslint-disable-next-line
    }, [competences, competenceSelectedPrimaries, competenceSelectedSecondaries])

    // METOLOGIAS
    const [methodologyOptions, setMethodologyOptions] = useState([])
    const [methodologySelectedPrimaries, setMethodologySelectedPrimaries] = useState([])
    const [methodologySelectedSecondaries, setMethodologySelectedSecondaries] = useState([])
    useEffect(() => {
        let primaryValuesToState = methodologySelectedPrimaries?.map(option => ({id: option.value, weighting: 'primary'}))
        let secondaryValuesToState = methodologySelectedSecondaries?.map(option => ({id: option.value, weighting: 'secondary'}))

        setState({
            ...state,
            requirements: {
                ...state.requirements,
                methodologies: [...primaryValuesToState, ...secondaryValuesToState]
            }
        })

        const primaryValues = methodologySelectedPrimaries?.map(option => option.value)
        const secondaryValues = methodologySelectedSecondaries?.map(option => option.value)
        const options = methodologies.filter(methodology => !primaryValues.includes(methodology.id) && !secondaryValues.includes(methodology.id))
            .map(methodology => ({ value: methodology.id, label: methodology.name }))
        setMethodologyOptions(options)
    // eslint-disable-next-line
    }, [methodologies, methodologySelectedPrimaries, methodologySelectedSecondaries])

    // NIVEL DE OFFICE
    const [officePrioritySelected, setOfficePrioritySelected] = useState(null)
    useEffect(() => {
        setState({
            ...state,
            requirements: {
                ...state.requirements,
                technologies: {
                    ...state.requirements?.technologies,
                    officeLevel: officePrioritySelected
                }
            }
        })
    // eslint-disable-next-line
    }, [officePrioritySelected])

    const [technologyOptions, setTechnologyOptions] = useState([]);
    const [technologySelectedPrimaries, setTechnologySelectedPrimaries] = useState([])
    const [technologySelectedSecondaries, setTechnologySelectedSecondaries] = useState([])
    useEffect(() => {
        let primaryValuesToState = technologySelectedPrimaries?.map(option => ({
            id: technologies.find(tech => tech?.technologies?.includes(option.label))?.id || technologies.find(tech => tech.name === option.label)?.id,
            name: option.label,
            weighting: 'primary'
        }));
        let secondaryValuesToState = technologySelectedSecondaries?.map(option => ({
            id: technologies.find(tech => tech?.technologies?.includes(option.label))?.id || technologies.find(tech => tech.name === option.label)?.id,
            name: option.label,
            weighting: 'secondary'
        }));

        setState({
            ...state,
            requirements: {
                ...state.requirements,
                technologies: {
                    ...state.requirements?.technologies,
                    technologyGroups: [...primaryValuesToState, ...secondaryValuesToState]
                }
            }
        });

        const savedTechnologies = [...technologySelectedPrimaries, ...technologySelectedSecondaries].map(option => option.label);
        const options = technologies
            .map(techGroup => (techGroup?.technologies ? techGroup?.technologies : [techGroup.name]))
            .flatMap(tech => tech)
            .filter(tech => !savedTechnologies.includes(tech))
            .map(tech => ({ value: tech, label: tech }));
        setTechnologyOptions(options)
    // eslint-disable-next-line
    }, [technologies, technologySelectedPrimaries, technologySelectedSecondaries]);

    const [softwareOptions, setSoftwareOptions] = useState([])
    const [softwareSelectedPrimaries, setSoftwareSelectedPrimaries] = useState([])
    const [softwareSelectedSecondaries, setSoftwareSelectedSecondaries] = useState([])
    useEffect(() => {
        let primaryValuesToState = softwareSelectedPrimaries?.map(option => ({id: option.value, weighting: 'primary'}))
        let secondaryValuesToState = softwareSelectedSecondaries?.map(option => ({id: option.value, weighting: 'secondary'}))

        setState({
            ...state,
            requirements: {
                ...state.requirements,
                technologies: {
                    ...state.requirements?.technologies,
                    softwares: [...primaryValuesToState, ...secondaryValuesToState]
                }
            }
        })

        const primaryValues = softwareSelectedPrimaries?.map(option => option.value)
        const secondaryValues = softwareSelectedSecondaries?.map(option => option.value)
        const options = softwares.filter(software => !primaryValues.includes(software) && !secondaryValues.includes(software))
            .map(software => ({ value: software, label: software }))
        setSoftwareOptions(options)
    // eslint-disable-next-line
    }, [softwares, softwareSelectedPrimaries, softwareSelectedSecondaries])

    const [ecosystemOptions, setEcosystemOptions] = useState([])
    const [ecosystemSelectedPrimaries, setEcosystemSelectedPrimaries] = useState([])
    const [ecosystemSelectedSecondaries, setEcosystemSelectedSecondaries] = useState([])
    useEffect(() => {
        let primaryValuesToState = ecosystemSelectedPrimaries?.map(option => ({id: option.value, weighting: 'primary'}))
        let secondaryValuesToState = ecosystemSelectedSecondaries?.map(option => ({id: option.value, weighting: 'secondary'}))

        setState({
            ...state,
            requirements: {
                ...state.requirements,
                technologies: {
                    ...state.requirements?.technologies,
                    ecosystems: [...primaryValuesToState, ...secondaryValuesToState]
                }
            }
        })

        const primaryValues = ecosystemSelectedPrimaries?.map(option => option.value)
        const secondaryValues = ecosystemSelectedSecondaries?.map(option => option.value)
        const options = ecosystems.filter(ecosystem => !primaryValues.includes(ecosystem) && !secondaryValues.includes(ecosystem))
            .map(ecosystem => ({ value: ecosystem, label: ecosystem }))
        setEcosystemOptions(options)
    // eslint-disable-next-line
    }, [ecosystems, ecosystemSelectedPrimaries, ecosystemSelectedSecondaries])

    useEffect(() => {
        if(state?.requirements?.language?.length > 0){
            const primaryLanguages = state?.requirements?.language.filter(language => language.weighting === 'primary')
            const secondaryLanguages = state?.requirements?.language.filter(language => language.weighting === 'secondary')
            setLanguageSelectedPrimaries(primaryLanguages ? primaryLanguages.map(language => ({value: language.id, label: languages.find(lang => lang.language === language.id)?.language})) : [])
            setLanguageSelectedSecondaries(secondaryLanguages ? secondaryLanguages.map(language => ({value: language.id, label: languages.find(lang => lang.language === language.id)?.language})) : [])
        }
        if(state?.requirements?.competences?.length > 0){
            const primaryCompetences = state?.requirements?.competences.filter(competence => competence.weighting === 'primary')
            const secondaryCompetences = state?.requirements?.competences.filter(competence => competence.weighting === 'secondary')
            setCompetenceSelectedPrimaries(primaryCompetences ? primaryCompetences.map(competence => ({value: competence.id, label: competences.find(comp => comp.id === competence.id)?.name})) : [])
            setCompetenceSelectedSecondaries(secondaryCompetences ? secondaryCompetences.map(competence => ({value: competence.id, label: competences.find(comp => comp.id === competence.id)?.name})) : [])
        }
        if(state?.requirements?.methodologies?.length > 0){
            const primaryMethodologies = state?.requirements?.methodologies.filter(methodology => methodology.weighting === 'primary')
            const secondaryMethodologies = state?.requirements?.methodologies.filter(methodology => methodology.weighting === 'secondary')
            setMethodologySelectedPrimaries(primaryMethodologies ? primaryMethodologies.map(methodology => ({value: methodology.id, label: methodologies.find(meto => meto.id === methodology.id)?.name})) : [])
            setMethodologySelectedSecondaries(secondaryMethodologies ? secondaryMethodologies.map(methodology => ({value: methodology.id, label: methodologies.find(meto => meto.id === methodology.id)?.name})) : [])
        }
        if(state?.requirements?.technologies?.technologyGroups?.length > 0){
            const primaryTechnologyGroups = state.requirements?.technologies?.technologyGroups.filter(group => group.weighting === 'primary')
            const secondaryTechnologyGroups = state.requirements?.technologies?.technologyGroups.filter(group => group.weighting === 'secondary')
            setTechnologySelectedPrimaries(primaryTechnologyGroups ? primaryTechnologyGroups.map(group => ({value: group.id, label: group.name})) : [])
            setTechnologySelectedSecondaries(secondaryTechnologyGroups ? secondaryTechnologyGroups.map(group => ({value: group.id, label: group.name})) : [])
        }
        if(state?.requirements?.technologies?.softwares?.length > 0){
            const primarySoftwares = state.requirements.technologies.softwares.filter(software => software.weighting === 'primary')
            const secondarySoftwares = state.requirements.technologies.softwares.filter(software => software.weighting === 'secondary')
            setSoftwareSelectedPrimaries(primarySoftwares ? primarySoftwares.map(software => ({value: software.id, label: software.id})) : [])
            setSoftwareSelectedSecondaries(secondarySoftwares ? secondarySoftwares.map(software => ({value: software.id, label: software.id})) : [])
        }
        if(state?.requirements?.technologies?.ecosystems?.length > 0){
            const primaryEcosystems = state.requirements.technologies.ecosystems.filter(ecosystem => ecosystem.weighting === 'primary')
            const secondaryEcosystems = state.requirements.technologies.ecosystems.filter(ecosystem => ecosystem.weighting === 'secondary')
            setEcosystemSelectedPrimaries(primaryEcosystems ? primaryEcosystems.map(ecosystem => ({value: ecosystem.id, label: ecosystem.id})) : [])
            setEcosystemSelectedSecondaries(secondaryEcosystems ? secondaryEcosystems.map(ecosystem => ({value: ecosystem.id, label: ecosystem.id})) : [])
        }
    // eslint-disable-next-line
    }, [])

    const [interviewFormState, setInterviewFormState] = useState(null)

    const handleInterviewActions = () => {
        if (!interviewFormState.responsibles || interviewFormState.responsibles.length === 0 || !interviewFormState.type) {
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('selection.interviewFormError')
            }).then(() => {
                return false
            })
        } else {
            const formCopy = {...interviewFormState}
            if (interviewFormState.action === "add") {
                setState({
                    ...state,
                    interviews: state.interviews ? [...state.interviews, {responsibles: formCopy.responsibles.map(r => r.value), type: formCopy.type.value}] : [{responsibles: formCopy.responsibles.map(r => r.value), type: formCopy.type.value}]
                })
            } else {
                setState({
                    ...state,
                    interviews: state.interviews.map((interview, interviewIndex) => {
                        if (interviewIndex === interviewFormState.index) {
                            return {
                                ...interview,
                                responsibles: formCopy.responsibles.map(r => r.value),
                                type: formCopy.type.value
                            }
                        } else {
                            return interview
                        }
                    })
                })
            }
            setInterviewFormState(null)
        }
    }

    const handleSelectInterview = (action, interview, index) => {
        if (action === "edit") {
            setInterviewFormState({
                action: "edit",
                type: {value: interview.type, label: t("selection." + interview.type)},
                responsibles: interview.responsibles.map(r => {
                    const staff = schoolStaffs?.find(s => s.staffId === r)

                    return {
                        label: staff?.name,
                        value: staff?.staffId
                    }
                }),
                _id: interview._id,
                index: index
            })
        }

        if (action === "delete") {
            Swal.fire({
                title: t('selection.deleteInterviewQuestion'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t('global.yes'),
                cancelButtonText: t('global.no')
            }).then((result) => {
                if (result.isConfirmed) {
                    setState({
                        ...state,
                        interviews: state.interviews.filter((_, interviewIndex) => interviewIndex !== index),
                        deletedInterviews: interview._id ? state.deletedInterviews ? [...state.deletedInterviews, interview._id] : [interview._id] : state.deletedInterviews
                    })
                }
            })
        }
    }

    const [editDescription, setEditDescription] = useState(false)

    const saveDescription = (e) => {
        setEditDescription(false)
    }

    const [startDateNow, setStartDateNow] = useState("false")
    const submitBtnRef = useRef(null)

    const handleStartDateChange = ({target}) => {
        setStartDateNow(target.value)
        if (target.value !== "false") {
            setState({
                ...state,
                startDate: new Date().toISOString().split('T')[0]
            })
        }
    }

    // PUBLICACIÓN
    const [publishModal, setPublishModal] = useState(false)
    const [publish, setPublish] = useState(false)
    const handlePublish = (e) => {
        e.preventDefault()
        if (!state.published) {
            setState({...state, published: true})
        }
        setPublish(true)
    }
    useEffect(() => {
        if (state.published) {
            setPublishModal(false)
        }

        if (publish) {
            submitBtnRef.current.click()
        }
    }, [state.published, publish, submitBtnRef])

    return (
        <>
            <Form onSubmit={submit} className='light-input'>
                <Row>
                    <Col>
                        <h3>{t('selection.programtitle')}</h3>
                        <p className='text-muted'>{t('selection.description2')}</p>
                    </Col>
                </Row>
                <Row className='mt-5 mb-3 align-items-center'>
                    <Col xs={3} className='d-flex align-items-center'>
                        <div className={`rounded-circle ${state.step === 1 ? 'bg-primary' : state.step > 1 ? 'bg-green cursor' : 'bg-muted'} selection-status me-2`} onClick={() => {
                        if (state.step > 1) {
                            setState({
                                ...state,
                                step: 1
                            })
                            setEditDescription(false)
                        }
                    }}>
                            {
                                state?.title && state?.incorporationDate && ((isMultiSchool && state?.school) || !isMultiSchool)
                                ?
                                    <img src='/images/check-white.svg' alt='Hecho'/>
                                :
                                    <></>
                            }
                        </div>
                        <div className={`step-connector ${state.step > 1 ? 'bg-green' : 'bg-muted'}`}/>
                    </Col>
                    <Col xs={3} className='d-flex align-items-center'>
                        <div className={`rounded-circle ${state.step === 2 ? 'bg-primary' : state.step > 2 ? 'bg-green cursor' : 'bg-muted'} selection-status me-2`} onClick={() => {
                        if (state.step > 2) {
                            setState({
                                ...state,
                                step: 2
                            })
                            setEditDescription(false)
                        }
                    }}>
                        {
                            state.requirementWeighting?.primary || state.requirementWeighting?.secondary || state.requirementWeighting?.values
                            ?
                                <img src='/images/check-white.svg' alt='Hecho'/>
                            :
                                <></>
                        }
                    </div>
                        <div className={`step-connector ${state.step > 2 ? 'bg-green' : 'bg-muted'}`}/>
                    </Col>
                    <Col xs={3} className='d-flex align-items-center'>
                        <div className={`rounded-circle ${state.step === 3 ? 'bg-primary' : state.step > 3 ? 'bg-green cursor' : 'bg-muted'} selection-status me-2`} onClick={() => {
                        if (state.step > 3) {
                            setState({
                                ...state,
                                step: 3
                            })
                            setEditDescription(false)
                        }
                    }}>
                        {
                            state.interviews && state.interviews.length > 0
                            ?
                                <img src='/images/check-white.svg' alt='Hecho'/>
                            :
                                <></>
                        }
                    </div>
                        <div className={`step-connector ${state.step > 3 ? 'bg-green' : 'bg-muted'}`}/>
                    </Col>
                    <Col xs={3} className='d-flex align-items-center'>
                        <div className={`rounded-circle ${state.step === 4 ? 'bg-primary' : state.step > 4 ? 'bg-green cursor' : 'bg-muted'} selection-status me-2`} onClick={() => {
                        if (state.step > 4) {
                            setState({
                                ...state,
                                step: 4
                            })
                            setEditDescription(false)
                        }
                    }}>
                        {
                            state.interviews && state.interviews.length > 0
                            ?
                                <img src='/images/check-white.svg' alt='Hecho'/>
                            :
                                <></>
                        }
                    </div>
                    </Col>
                </Row>
                <Row className='mb-5 align-items-center'>
                    <Col xs={3} className={`${state.step > 1 ? 'cursor' : ''} ${state.step < 1 ? 'text-muted' : ''}`} onClick={() => {
                        if (state.step > 1) {
                            setState({
                                ...state,
                                step: 1
                            })
                            setEditDescription(false)
                        }
                    }}>
                        {t('selection.faseNumber', {number: 1})}
                        <div className='fw-bold'>{t('selection.generalInformation')}</div>
                    </Col>
                    <Col xs={3} className={`${state.step > 2 ? 'cursor' : ''} ${state.step < 2 ? 'text-muted' : ''}`} onClick={() => {
                        if (state.step > 2) {
                            setState({
                                ...state,
                                step: 2
                            })
                            setEditDescription(false)
                        }
                    }}>
                        {t('selection.faseNumber', {number: 2})}
                        <div className='fw-bold'>{t('selection.selectionDetails')}</div>
                    </Col>
                    <Col xs={3} className={`${state.step > 3 ? 'cursor' : ''} ${state.step < 3 ? 'text-muted' : ''}`} onClick={() => {
                        if (state.step > 3) {
                            setState({
                                ...state,
                                step: 3
                            })
                            setEditDescription(false)
                        }
                    }}>
                        {t('selection.faseNumber', {number: 3})}
                        <div className='fw-bold'>{t('selection.selectionConfiguration')}</div>
                    </Col>
                    <Col xs={3} className={`${state.step > 4 ? 'cursor' : ''} ${state.step < 4 ? 'text-muted' : ''}`} onClick={() => {
                        if (state.step > 4) {
                            setState({
                                ...state,
                                step: 4
                            })
                            setEditDescription(false)
                        }
                    }}>
                        {t('selection.faseNumber', {number: 4})}
                        <div className='fw-bold'>{t('selection.summary')}</div>
                    </Col>
                </Row>
                <div className='my-3 bg-grey p-4'>
                    {
                        state?.step === 1
                        ?
                            <>
                                <div className='border-bottom border-dark pb-1 mb-5'>
                                    {t('selection.generalInformation').toUpperCase()}
                                </div>
                                {
                                    isMultiSchool
                                    ?
                                        <>
                                            <Form.Group className='my-3'>
                                                <Form.Label htmlFor='title'>{t('selection.processtitle')}</Form.Label>
                                                <Form.Control
                                                    type='text'
                                                    name='title'
                                                    placeholder={t('selection.processtitleplaceholder')}
                                                    value={state?.title ||  ''}
                                                    onChange={handleInputChange}
                                                    required
                                                    readOnly={state.started === true && !isAdmin}
                                                />
                                            </Form.Group>
                                            <Row>
                                                <Col xs={12} md={8} className='my-3'>
                                                    <Form.Label htmlFor='school'>{t('selection.school')}</Form.Label>
                                                    <Select
                                                        className="select"
                                                        name='school'
                                                        options={schoolsOptions}
                                                        value={state?.school}
                                                        onChange={handleSchoolChange}
                                                        required
                                                        isDisabled={state.started === true && !isAdmin}
                                                    />
                                                </Col>
                                                <Col xs={12} lg={4} className="my-3">
                                                    <Form.Label htmlFor='incorporationDate'>
                                                        {t('selection.shortIncorporationDate')}
                                                        <OverlayTrigger placement="bottom"
                                                            overlay={<Tooltip id="tooltip">
                                                                <p>{t('selection.infoDateIncorporation')}</p>
                                                            </Tooltip>}
                                                        >
                                                            <img src="/images/info.svg" alt="Info" className="ms-2" />
                                                        </OverlayTrigger>

                                                    </Form.Label>
                                                    <Form.Control
                                                        type='date'
                                                        name='incorporationDate'
                                                        value={state?.incorporationDate ||  ''}
                                                        onChange={handleDateChange}
                                                        min={new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]}
                                                        required
                                                        disabled={state.started === true && !isAdmin}
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                    :
                                        <Row>
                                            <Col xs={12} md={8}>
                                                <Form.Group>
                                                    <Form.Label htmlFor='title'>{t('selection.processtitle')}</Form.Label>
                                                    <Form.Control
                                                        type='text'
                                                        name='title'
                                                        placeholder={t('selection.processtitleplaceholder')}
                                                        value={state?.title ||  ''}
                                                        onChange={handleInputChange}
                                                        required
                                                        readOnly={state.started === true && !isAdmin}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} lg={4}>
                                                <Form.Label htmlFor='incorporationDate'>
                                                    {t('selection.shortIncorporationDate')}
                                                    <OverlayTrigger placement="bottom"
                                                        overlay={<Tooltip id="tooltip">
                                                            <p>{t('selection.infoDateIncorporation')}</p>
                                                        </Tooltip>}
                                                    >
                                                        <img src="/images/info.svg" alt="Info" className="ms-2" />
                                                    </OverlayTrigger>

                                                </Form.Label>
                                                <Form.Control
                                                    type='date'
                                                    name='incorporationDate'
                                                    value={state?.incorporationDate ||  ''}
                                                    onChange={handleDateChange}
                                                    min={new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]}
                                                    required
                                                    disabled={state.started === true && !isAdmin}
                                                />
                                            </Col>
                                        </Row>
                                }
                            </>
                        :
                            <></>
                    }
                    {
                        state?.step === 2
                        ?
                            <>
                                <div className='border-bottom border-dark pb-1 mb-5'>
                                    {t('selection.selectionDetails').toUpperCase()}
                                </div>
                                <Row>
                                    <Col xs={12} md={6} className='mb-3'>
                                        <Form.Label className="me-2 mt-2 mb-1" htmlFor="substitution">{t('selection.bachilleribrequired')}</Form.Label>
                                        <div className='d-lg-flex align-items-center'>
                                            <span className='text-muted me-2'>{t("global.no")}</span>
                                            <Form.Check
                                                type="switch"
                                                name="bachillerIB"
                                                onChange={(e) => handleSwitchChange(e.target.checked, 'bachillerIB')}
                                                checked={state.bachillerIB === true}
                                                disabled={state.started === true && !isAdmin}
                                            />
                                            <span className='text-muted ms-2'>{t("global.yes")}</span>
                                        </div>
                                    </Col>
                                    <Col xs={12} md={6} className="mb-3">
                                        <Form.Label className="me-2 mt-2 mb-1" htmlFor="publicData">{t('selection.publicData')}</Form.Label>
                                        <div className='d-lg-flex align-items-center'>
                                            <span className='text-muted me-2'>{t("global.no")}</span>
                                            <Form.Check
                                                type="switch"
                                                name="publicData"
                                                onChange={(e) => handleSwitchChange(e.target.checked, 'publicData')}
                                                checked={state.publicData === true}
                                                disabled={state.started === true && !isAdmin}
                                            />
                                            <span className='text-muted ms-2'>{t("global.yes")}</span>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6} className='my-3'>
                                        <Form.Label htmlFor='specialty'>{t('selection.specialty')}</Form.Label>
                                        <Select
                                            className="select"
                                            name='specialty'
                                            options={levelSelect?.options}
                                            value={levelSelect?.selected}
                                            onChange={handleSelectLinesChange}
                                            required
                                            isDisabled={state.started === true && !isAdmin}
                                        />
                                    </Col>
                                    <Col xs={12} md={6} className='my-3'>
                                        <Form.Label htmlFor='subject'>{t('selection.subjects')}</Form.Label>
                                        <Select
                                            className="select"
                                            name='subject'
                                            options={subjectsSelect?.options}
                                            value={subjectsSelect?.selected}
                                            onChange={handleSelectSubjectsChange}
                                            required
                                            isDisabled={state.started === true && !isAdmin}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} className='my-3'>
                                        <Form.Label htmlFor='contractType' className='mb-2'>{t('profile.candidate.contractType')}</Form.Label>
                                        <div className='d-lg-flex'>
                                            <div className="d-flex align-items-center mb-2">
                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="practice">{t('profile.candidate.practices')}</Form.Label>
                                                <Form.Check
                                                    className="me-5"
                                                    type="switch"
                                                    name="contractType"
                                                    id="practice"
                                                    onChange={() => handleSwitchChange('practice','contractType')}
                                                    checked={state?.contractType === 'practice'}
                                                    disabled={state.started === true && !isAdmin}
                                                />
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="substitution">{t('profile.candidate.substitution')}</Form.Label>
                                                <Form.Check
                                                    className="me-5"
                                                    type="switch"
                                                    name="contractType"
                                                    id="substitution"
                                                    onChange={() => handleSwitchChange('substitution','contractType')}
                                                    checked={state?.contractType === 'substitution'}
                                                    disabled={state.started === true && !isAdmin}
                                                />
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('profile.candidate.undefined')}</Form.Label>
                                                <Form.Check
                                                    className="me-3"
                                                    type="switch"
                                                    name="contractType"
                                                    id="work"
                                                    onChange={() => handleSwitchChange('work','contractType')}
                                                    checked={state?.contractType === 'work'}
                                                    disabled={state.started === true && !isAdmin}
                                                />
                                            </div>
                                            {
                                                state?.contractType === 'work' &&
                                                <div className="d-flex align-items-center mb-2">
                                                    <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.fixedDiscontinuous')}</Form.Label>
                                                    <Form.Check
                                                        className="me-3"
                                                        type="switch"
                                                        name="fixedDiscontinuous"
                                                        id="fixedDiscontinuous"
                                                        onChange={({target}) => handleSwitchChange(target.checked,'fixedDiscontinuous')}
                                                        checked={state?.fixedDiscontinuous}
                                                        disabled={state.started === true && !isAdmin}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                                {
                                    state?.contractType === 'substitution'
                                    ?
                                    <Row className='border-1'>
                                        <Col xs={12} lg={8} className="my-2">
                                            <Form.Label htmlFor='sex'>{t('selection.reasonReplacement')}</Form.Label>
                                            <Select
                                                className="select"
                                                name='reasonReplacement'
                                                options={reasons?.options}
                                                value={reasons?.selected}
                                                onChange={handleReasonsChange}
                                                required
                                                isDisabled={state.started === true && !isAdmin}
                                            />
                                        </Col>
                                        {/* <Col xs={12} lg={6} className="my-2">
                                            <Form.Label htmlFor='initReplacementDate'>{t('selection.initReplacementDate')}</Form.Label>
                                            <Form.Control
                                                type='date'
                                                name='initReplacementDate'
                                                value={state?.initReplacement ||  null}
                                                onChange={handleInputChange}
                                                required
                                                disabled={state.started === true && !isAdmin}
                                            />
                                        </Col> */}
                                        <Col xs={12} lg={4} className="my-2">
                                            <Form.Label htmlFor='endReplacementDate'>{t('selection.endReplacementDate')}</Form.Label>
                                            <Form.Control
                                                type='date'
                                                name='endReplacementDate'
                                                value={state?.endReplacement ||  null}
                                                onChange={handleInputChange}
                                                required
                                                disabled={state.started === true && !isAdmin}
                                            />
                                        </Col>
                                    </Row>
                                    :
                                    <></>
                                }
                                <Row>
                                    <Col xs={12} md={6} className='my-3'>
                                        <Form.Label htmlFor='workdayType' className='mb-2'>{t('profile.candidate.idealPosition.workDay.label')}</Form.Label>
                                        <Select
                                            className="select"
                                            name='workdayType'
                                            options={["full", "half", "partial"].map(type => {return {label: t('profile.candidate.idealPosition.workDay.' + type), value: type}})}
                                            value={state.workdayType ? {label: t('profile.candidate.idealPosition.workDay.' + state.workdayType), value: state.workdayType} : null}
                                            onChange={selectedValue => handleInputChange({target: {name: "workdayType", value: selectedValue.value}})}
                                        />
                                    </Col>
                                    <Col xs={12} md={6} className='my-3'>
                                        <Form.Label htmlFor='ageRange'>{t('selection.rangeage')}: {state?.ageRange?.min} - {state?.ageRange?.max}</Form.Label>
                                        <Slider
                                            className='mt-3'
                                            range
                                            name='ageRange'
                                            min={17}
                                            max={80}
                                            value={[state?.ageRange?.min || 17, state?.ageRange?.max || 90]}
                                            onChange={(value) => handleSliderChange(value[0], value[1])}
                                            disabled={state.started === true && !isAdmin}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} className='my-3'>
                                        <Form.Label htmlFor='minimumSalary'>{t('selection.minimumSalary')}</Form.Label>
                                        <Form.Control
                                            name='minimumSalary'
                                            placeholder={t('profile.candidate.idealPosition.minWagePlaceholder')}
                                            value={state?.minimumSalary ||  ''}
                                            onChange={handleInputChange}
                                            readOnly={state.started === true && !isAdmin}
                                        />
                                    </Col>
                                </Row>
                                <Row className='mt-5'>
                                    <div className='border-bottom border-dark pb-1 mb-4'>
                                        {t('selection.requirements').toUpperCase()}
                                    </div>
                                    <Col xs={12} className='my-3'>
                                        <Form.Label htmlFor='wighting-of-requirements'>{t('selection.weighingrequirements')}</Form.Label>
                                        <OverlayTrigger placement="top"
                                            overlay={<Tooltip id="tooltip">
                                                        <p>
                                                            <small>{t('selection.requirementsinfo')}</small>
                                                        </p>
                                                        <p>
                                                            <small>{t('selection.weighingrequirementsinfo')}</small>
                                                        </p>
                                                    </Tooltip>}
                                        >
                                            <img src="/images/info.svg" alt="Info" className="ms-2" />
                                        </OverlayTrigger>
                                        <div className='d-lg-flex'>
                                            <div className='d-flex align-items-center me-md-5'>
                                                <Form.Label className='w-100' htmlFor='primary'>{t('selection.primary')}</Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        name='primary'
                                                        value={state?.requirementWeighting?.primary ||  0}
                                                        onChange={handleInputWeightChange}
                                                        aria-label="Primary"
                                                        aria-describedby="primary"
                                                        readOnly={state.started === true && !isAdmin}
                                                    />
                                                    <InputGroup.Text id="primary">%</InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                            <div className='d-flex align-items-center me-md-5'>
                                                <Form.Label className='w-100' htmlFor='secondary'>{t('selection.secondary')}</Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        name='secondary'
                                                        value={state?.requirementWeighting?.secondary ||  0}
                                                        onChange={handleInputWeightChange}
                                                        aria-label="Secondary"
                                                        aria-describedby="secondary"
                                                        readOnly={state.started === true && !isAdmin}
                                                    />
                                                    <InputGroup.Text id="secondary">%</InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <Form.Label className='w-100' htmlFor='values'>{t('selection.values')}</Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        name='values'
                                                        value={state?.requirementWeighting?.values ||  ''}
                                                        onChange={handleInputWeightChange}
                                                        aria-label="Values"
                                                        aria-describedby="values"
                                                        readOnly={state.started === true && !isAdmin}
                                                    />
                                                    <InputGroup.Text id="values">%</InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6} className='my-3'>
                                        <Card className='py-3 px-4 bg-grey border border-secondary rounded'>
                                            <Card.Body>
                                                {t('selection.primary')}
                                                <Col xs={12} className='mt-5'>
                                                    {languages?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='languages'>{t('selection.languages')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='languages'
                                                                options={languageOptions}
                                                                value={languageSelectedPrimaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 4) {
                                                                        setLanguageSelectedPrimaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxLanguages')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    {competences?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='competences'>{t('selection.competences')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='competences'
                                                                options={competenceOptions}
                                                                value={competenceSelectedPrimaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 10) {
                                                                        setCompetenceSelectedPrimaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxCompetences')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    {methodologies?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='methodologies'>{t('selection.methodologies')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='methodologies'
                                                                options={methodologyOptions}
                                                                value={methodologySelectedPrimaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 6) {
                                                                        setMethodologySelectedPrimaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxMethodologies')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    {technologies?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='technologies'>{t('selection.technologies')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='technologies'
                                                                options={technologyOptions}
                                                                value={technologySelectedPrimaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 8) {
                                                                        setTechnologySelectedPrimaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxTechnologies')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    {softwares?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='softwares'>{t('selection.softwares')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='softwares'
                                                                options={softwareOptions}
                                                                value={softwareSelectedPrimaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 8) {
                                                                        setSoftwareSelectedPrimaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxSoftwares')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    {ecosystems?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='ecosystems'>{t('selection.ecosystems')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='ecosystems'
                                                                options={ecosystemOptions}
                                                                value={ecosystemSelectedPrimaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 8) {
                                                                        setEcosystemSelectedPrimaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxEcosystems')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    <Form.Label htmlFor='officePriority'>{t('selection.officepriority')}</Form.Label>
                                                    <Form.Select name='officePriority' value={state?.requirements?.technologies?.officeLevel || officePrioritySelected} onChange={(e) => setOfficePrioritySelected(e.target.value)} disabled={state.started === true && !isAdmin}>
                                                        <option value='none'>{t('selection.officenotpriority')}</option>
                                                        <option value='medium'>{t('selection.officemedium')}</option>
                                                        <option value='high'>{t('selection.officehigh')}</option>
                                                    </Form.Select>
                                                </Col>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col xs={6} className='my-3'>
                                        <Card className='py-3 px-4 bg-grey border border-secondary rounded'>
                                            <Card.Body>
                                                {t('selection.secondary')}
                                                <Col xs={12} className='mt-5'>
                                                    {languages?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='languages'>{t('selection.languages')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='languages'
                                                                options={languageOptions}
                                                                value={languageSelectedSecondaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 4) {
                                                                        setLanguageSelectedSecondaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxLanguages')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    {competences?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='competences'>{t('selection.competences')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='competences'
                                                                options={competenceOptions}
                                                                value={competenceSelectedSecondaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 10) {
                                                                        setCompetenceSelectedSecondaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxCompetences')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    {methodologies?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='methodologies'>{t('selection.methodologies')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='methodologies'
                                                                options={methodologyOptions}
                                                                value={methodologySelectedSecondaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 6) {
                                                                        setMethodologySelectedSecondaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxMethodologies')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    {technologies?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='technologies'>{t('selection.technologies')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='technologies'
                                                                options={technologyOptions}
                                                                value={technologySelectedSecondaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 8) {
                                                                        setTechnologySelectedSecondaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxTechnologies')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    {softwares?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='softwares'>{t('selection.softwares')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='softwares'
                                                                options={softwareOptions}
                                                                value={softwareSelectedSecondaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 8) {
                                                                        setSoftwareSelectedSecondaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxSoftwares')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                                <Col xs={12} className='my-3'>
                                                    {ecosystems?.length > 0 ?
                                                        <>
                                                            <Form.Label htmlFor='ecosystems'>{t('selection.ecosystems')}</Form.Label>
                                                            <Select
                                                                className="select"
                                                                name='ecosystems'
                                                                options={ecosystemOptions}
                                                                value={ecosystemSelectedSecondaries}
                                                                onChange={(selectedOptions) => {
                                                                    if (selectedOptions.length < 8) {
                                                                        setEcosystemSelectedSecondaries(selectedOptions);
                                                                    } else {
                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: t('selection.maxSoftwaecosystems')
                                                                        });
                                                                    }
                                                                }}
                                                                isMulti
                                                                required
                                                                isDisabled={state.started === true && !isAdmin}
                                                            />
                                                        </>
                                                    :
                                                        <></>
                                                    }
                                                </Col>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </>
                        :
                            <></>
                    }
                    {
                        state?.step === 3
                        ?
                            <>
                                <div className='border-bottom border-dark pb-1 mb-5'>
                                    {t('selection.selectionDetails').toUpperCase()}
                                </div>
                                <Card className='my-3'>
                                    <Card.Body className={`p-4 ${state.videoPresentation ? 'pb-5' : ''}`}>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-primary details-step'>1</div>
                                                <div className='fs-5 ms-3'>{t("selection.videoHeader")}</div>
                                            </div>
                                            <Form.Check
                                                className="me-2"
                                                type="switch"
                                                name="videoPresentation"
                                                onChange={(e) => handleSwitchChange(e.target.checked,'videoPresentation')}
                                                checked={state.videoPresentation === true}
                                                disabled={state.started === true && !isAdmin}
                                            />
                                        </div>
                                        {
                                            state.videoPresentation
                                            ?
                                                <>
                                                    <div className='text-muted mt-3 mb-5'>
                                                        {t("selection.videoDescription")}
                                                    </div>
                                                    <Row className='mb-4'>
                                                        <Col xs={6} lg={4}>{t('selection.questionsDefault')}</Col>
                                                        <Col xs={6} lg={8}>{t('selection.questionsSchool')}</Col>
                                                    </Row>
                                                    {['first','second','third','fourth'].map((option) => (
                                                        <Row key={option} className='my-3'>
                                                            <Col xs={6} lg={4}>
                                                                <Select
                                                                    className="select"
                                                                    name={`subject${option}`} 
                                                                    options={translatedQuestions}
                                                                    onChange={(e) => handleSelectQuestionsChange(e, option)}
                                                                    isDisabled={state.started === true && !isAdmin}
                                                                    placeholder={t("selection.defaultQuestionPlaceholder")}
                                                                />
                                                            </Col>
                                                            <Col xs={6} lg={8}>
                                                                <Form.Control
                                                                    name={option}
                                                                    value={state?.questions[option]} 
                                                                    onChange={handleInputQuestionChange}
                                                                    disabled={state.started === true && !isAdmin}
                                                                    placeholder={t("selection.customQuestionPlaceholder")}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                </>
                                            :
                                                <></>
                                        }
                                    </Card.Body>
                                </Card>
                                <Card className='my-3'>
                                    <Card.Body className={`p-4 ${state.videoPresentation ? 'pb-5' : ''}`}>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-primary details-step'>2</div>
                                                <div className='fs-5 ms-3'>{t("selection.interviewHeader")}</div>
                                            </div>
                                            <Button type='button' variant='outline-primary' onClick={() => {setInterviewFormState({action: 'add'})}}>
                                                <img src="/images/plus.svg" alt='+' className='me-3'/>
                                                {t("selection.addInterview")}
                                            </Button>
                                        </div>
                                        {
                                            state.interviews?.length > 0
                                            ?
                                                <div className="mt-3">
                                                    <Table>
                                                        <thead>
                                                            <tr>
                                                                <th className='fs-5'>{t("selection.interviewsNumber")}</th>
                                                                <th className='fs-5'>{t("selection.responsibles")}</th>
                                                                <th className='fs-5'>{t("selection.mode")}</th>
                                                                <th className='fs-5'>{t("global.actions")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className='border-muted'>
                                                            {state.interviews.map((interview, index) => (
                                                                <tr key={index}>
                                                                    <td className='py-3'>{index + 1}</td>
                                                                    <td className='py-3'>{(interview.responsibles.map(r => schoolStaffs?.find(s => s.staffId === r)?.name) ||[]).join(', ')}</td>
                                                                    <td className='py-3'>{t("selection." + interview.type)}</td>
                                                                    <td className='py-3'>
                                                                        <Dropdown drop='start'>
                                                                            <Dropdown.Toggle as="img" src="/images/options.svg" className='cursor'/>
                                                                            <Dropdown.Menu>
                                                                                <Dropdown.Item as="div" className='cursor' onClick={() => handleSelectInterview("edit", interview, index)}>
                                                                                    {t("global.edit")}
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item as="div" className='cursor' onClick={() => handleSelectInterview("delete", interview, index)}>
                                                                                    {t("global.delete")}
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            :
                                                <></>
                                        }
                                    </Card.Body>
                                </Card>
                            </>
                        :
                            <></>
                    }
                    {
                        state?.step === 4
                        ?
                            <>
                                <div className='border-bottom border-dark pb-1 mb-5 fs-5'>
                                    {t('selection.summaryTitle')}
                                </div>
                                <Card>
                                    <Card.Body className='d-flex p-4 justify-content-between'>
                                        <div className='d-flex align-items-center gap-4'>
                                            <div className='selection-avatar'>
                                                {school?.user?.image
                                                    ?
                                                        <img className="img-profile" alt="Preview" src={typeof school.user?.image === 'string' ? school.user?.image : URL.createObjectURL(school.user?.image)} />
                                                    :
                                                        <div className="img-profile"></div>
                                                }
                                            </div>
                                            <div>
                                                <p className='fw-bold mb-1'>{ school?.school?.name }</p>
                                                {
                                                    school?.school?.town || school?.school?.province
                                                    ?
                                                        <p className='mb-1'>
                                                            {towns.find(t => t.value === school?.school?.town)?.label || ''}
                                                            {provinces.find(p => p.value === school?.school?.province)?.label ? ` - ${provinces.find(p => p.value === school?.school?.province)?.label}` : ''}
                                                        </p>
                                                    :
                                                        <></>
                                                }
                                            </div>
                                        </div>
                                        {
                                            !state.published
                                            ?
                                                <div>
                                                    <Button variant='primary' type='button' onClick={() => setPublishModal(true)}>{t('selection.publish')}</Button>
                                                </div>
                                            :
                                                <></>
                                        }
                                    </Card.Body>
                                </Card>
                                <Card className='mt-3'>
                                    <Card.Body className='p-4'>
                                        <div className='border-bottom border-dark pb-1 mb-5 fs-5'>
                                            {t('selection.summaryTitle')}
                                        </div>
                                        <Row>
                                            <Col xs={9}>
                                                <Container className='cuadro-datos-generales'>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{t('selection.title')}</div>
                                                            <div className='data'>{state?.title}</div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{t('selection.incorporationDate')}</div>
                                                            <div className='data'>{state?.incorporationDate ? new Date(state?.incorporationDate).toLocaleDateString() : '-'}</div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{(t('selection.specialty'))}</div>
                                                            <div className='data'>{(levelSelect?.options?.find(level => level.value === state?.specialty)?.label)}</div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{(t('selection.subject'))}</div>
                                                            <div className='data'>{(subjectsSelect?.options?.find(subject => subject.value === state?.subject)?.label)}</div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{t('profile.candidate.contractType')}</div>
                                                            <div className='data'>{state?.fixedDiscontinuous ? t('selection.fixedDiscontinuous') : t('profile.candidate.' + state?.contractType)}</div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{t('profile.candidate.idealPosition.workDay.label')}</div>
                                                            <div className='data'>{t('profile.candidate.idealPosition.workDay.' + state?.workdayType)}</div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{t('selection.minimumSalary')}</div>
                                                            <div className='data'>{state?.minimumSalary || t('selection.byAgreement')}</div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{t('selection.primary')}</div>
                                                            <div className='data'>{state?.requirementWeighting?.primary ||  0}%</div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{t('selection.secondary')}</div>
                                                            <div className='data'>{state?.requirementWeighting?.secondary ||  0}%</div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{t('selection.values')}</div>
                                                            <div className='data'>{state?.requirementWeighting?.values ||  0}%</div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                            <Accordion>
                                                                <div className='d-flex justify-content-between'>
                                                                    <div className='title'>{t('selection.primary')}</div>
                                                                    <CustomAccordion eventKey='primary'>{t('selection.seeRequirements')}</CustomAccordion>
                                                                </div>
                                                                <Accordion.Collapse eventKey='primary' className='border-top border-muted mt-3'>
                                                                    <>
                                                                        {
                                                                            languageSelectedPrimaries && languageSelectedPrimaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.languages')}</div>
                                                                                    <div>{languageSelectedPrimaries.map(lang => lang.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        {
                                                                            competenceSelectedPrimaries && competenceSelectedPrimaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.competences')}</div>
                                                                                    <div>{competenceSelectedPrimaries.map(comp => comp.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        {
                                                                            methodologySelectedPrimaries && methodologySelectedPrimaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.methodologies')}</div>
                                                                                    <div>{methodologySelectedPrimaries.map(met => met.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        {
                                                                            technologySelectedPrimaries && technologySelectedPrimaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.technologies')}</div>
                                                                                    <div>{technologySelectedPrimaries.map(tec => tec.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        {
                                                                            softwareSelectedPrimaries && softwareSelectedPrimaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.softwares')}</div>
                                                                                    <div>{softwareSelectedPrimaries.map(software => software.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        {
                                                                            ecosystemSelectedPrimaries && ecosystemSelectedPrimaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.ecosystems')}</div>
                                                                                    <div>{ecosystemSelectedPrimaries.map(eco => eco.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        <div className="my-3">
                                                                            <div className='fw-bold'>{t('profile.candidate.officeLevel.title')}</div>
                                                                            <div>{t('selection.' + (state?.requirements?.technologies?.officeLevel && state?.requirements?.technologies?.officeLevel !== 'none' ? `office${state?.requirements?.technologies?.officeLevel}` : 'officenotpriority'))}</div>
                                                                        </div>
                                                                    </>
                                                                </Accordion.Collapse>
                                                            </Accordion>
                                                    </Row>
                                                    <Row className='py-3'>
                                                            <Accordion>
                                                                <div className='d-flex justify-content-between'>
                                                                    <div className='title'>{t('selection.secondary')}</div>
                                                                    <CustomAccordion eventKey='secondary'>{t('selection.seeRequirements')}</CustomAccordion>
                                                                </div>
                                                                <Accordion.Collapse eventKey='secondary' className='border-top border-muted mt-3'>
                                                                    <>
                                                                        {
                                                                            languageSelectedSecondaries && languageSelectedSecondaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.languages')}</div>
                                                                                    <div>{languageSelectedSecondaries.map(lang => lang.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        {
                                                                            competenceSelectedSecondaries && competenceSelectedSecondaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.competences')}</div>
                                                                                    <div>{competenceSelectedSecondaries.map(comp => comp.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        {
                                                                            methodologySelectedSecondaries && methodologySelectedSecondaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.methodologies')}</div>
                                                                                    <div>{methodologySelectedSecondaries.map(met => met.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        {
                                                                            technologySelectedSecondaries && technologySelectedSecondaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.technologies')}</div>
                                                                                    <div>{technologySelectedSecondaries.map(tec => tec.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        {
                                                                            softwareSelectedSecondaries && softwareSelectedSecondaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.softwares')}</div>
                                                                                    <div>{softwareSelectedSecondaries.map(software => software.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                        {
                                                                            ecosystemSelectedSecondaries && ecosystemSelectedSecondaries.length > 0
                                                                            ?
                                                                                <div className="my-3">
                                                                                    <div className='fw-bold'>{t('selection.ecosystems')}</div>
                                                                                    <div>{ecosystemSelectedSecondaries.map(eco => eco.label).join(', ')}</div>
                                                                                </div>
                                                                            :
                                                                                <></>
                                                                        }
                                                                    </>
                                                                </Accordion.Collapse>
                                                            </Accordion>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{(t('selection.videoPresentation'))}</div>
                                                            <div className='d-flex justify-content-end align-items-center'>
                                                                <div className='data'>{state?.videoPresentation ? t('global.yes') : t('global.no')}</div>
                                                            </div>
                                                        </div>
                                                    </Row>
                                                    <Row className='py-3'>
                                                        <div className='d-flex justify-content-between'>
                                                            <div className='title'>{(t('selection.interviews'))}</div>
                                                            <div className='d-flex justify-content-end align-items-center'>
                                                                <div className='data'>{state?.interviews?.length}</div>
                                                            </div>
                                                        </div>
                                                    </Row>
                                                </Container>
                                            </Col>
                                            <Col xs={3} className='text-center'>
                                                <h6 className='fw-bold'>{t('selection.successProbability')}</h6>
                                                <div className='w-50 mx-auto my-5'>
                                                    <Doughnut
                                                        data={{
                                                            datasets: [
                                                                {
                                                                    data: [
                                                                        maxScore || 0,
                                                                        100 - Number(maxScore || 0),
                                                                    ],
                                                                    backgroundColor: ['#89CF2B', '#DEF3BE'],
                                                                    hoverBackgroundColor: ['#89CF2BAA', '#DEF3BEAA'],
                                                                },
                                                            ],
                                                        }}
                                                        options={{...ChartJsOptions, centerText: {text: maxScore ? Math.trunc(maxScore) : '0'}}}
                                                    />
                                                </div>
                                                <h6 className='fw-bold'>{t('selection.congratulations').toUpperCase()}</h6>
                                                <div>{t('selection.maxAffinityDescription', {percentage: maxScore})}</div>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                                <div className='border-bottom border-dark pb-1 my-5 fs-5'>
                                    {t('selection.description')}
                                </div>
                                <Card>
                                    <Card.Body className='p-4'>
                                        {
                                            !editDescription
                                            ?
                                                <>
                                                    <div dangerouslySetInnerHTML={{__html: (state.profileDescription?.length > 256 ? state.profileDescription?.substring(0, 256) + '...' : state.profileDescription)?.replace("\n", "<br>")}}/>
                                                    <div className='d-flex justify-content-center gap-3 mt-3'>
                                                        <Button variant='white' onClick={() => setEditDescription(true)}>{t('global.edit')}</Button>
                                                        {
                                                            IALoading
                                                            ?
                                                                <Button variant='primary' className='disabled' disabled type='button'><span className="spinner-border spinner-border-sm align-middle"></span></Button>
                                                            :
                                                                <Button variant='primary' onClick={() => generateDescription()}><i className='fa-solid fa-wand-magic-sparkles me-2'/>{t('school.selection.generateDescription')}</Button>
                                                        }
                                                    </div>
                                                </>
                                            :
                                                <>
                                                    <div>
                                                        <Form.Control
                                                            as="textarea"
                                                            name='profileDescription'
                                                            rows='20'
                                                            value={state?.profileDescription ||  ''}
                                                            onChange={handleInputChange}
                                                            required
                                                            readOnly={state.started === true && !isAdmin}
                                                        />
                                                    </div>
                                                    <div className='d-flex justify-content-end mt-3'>
                                                        <Button variant='primary' className='me-2' onClick={saveDescription}>{t('global.save')}</Button>
                                                    </div>
                                                </>
                                        }
                                    </Card.Body>
                                </Card>
                            </>
                        :
                            <></>
                    }
                    {(state.started !== true || isAdmin) && (
                        <>
                            <Row className="mb-3 mt-5 d-flex justify-content-end">
                                <Col xs='12' className='d-flex justify-content-end'>
                                    {
                                        !state.step || state.step === 1
                                        ?
                                            <Link to={`/${isAdmin ? 'admin' : isMultiSchool ? 'multischool' : 'school' }/activeprocesses`} className='btn btn-white my-2 me-2 px-4'>
                                                {t('selection.cancelSelection')}
                                            </Link>
                                        :
                                            <Button variant='white' className='my-2 me-2 px-4' type='button' onClick={() => {
                                                setState({
                                                    ...state,
                                                    step: state.step - 1
                                                })
                                            }}>
                                                {t("selection.previousStep")}
                                            </Button>
                                    }
                                    {
                                        !state.published || state.step < 4
                                        ?
                                            state.step < 4
                                            ?
                                                <Button variant='primary' type="submit" className="my-2">{t('selection.nextStep')}</Button>
                                            :
                                                loading
                                                ?
                                                    <Button variant='secondary' type='button' disabled className="my-2 me-2 disabled">
                                                        <span className="spinner-border spinner-border-sm align-middle"></span>
                                                    </Button>
                                                :
                                                    <>
                                                        <Button variant='secondary' type='submit' className="my-2 me-2">{t('selection.asborrador')}</Button>
                                                        <Button variant='primary' type='button' className="my-2" onClick={() => setPublishModal(true)}>{t('selection.publish')}</Button>
                                                    </>
                                        :
                                            <></>
                                    }
                                </Col>
                            </Row>
                        </>
                    )}
                </div>
            </Form>
            <Modal show={interviewFormState ? true : false} onHide={() => setInterviewFormState(null)}>
                <Modal.Header className='border-0 p-4' closeButton>
                    <Modal.Title>{t(`selection.${interviewFormState?.action}InterviewTitle`)}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='border-0 p-4'>
                    <div className='my-3'>
                        <Form.Label>{t("selection.responsibles")}</Form.Label>
                        <Select
                            className="select"
                            name='responsibles'
                            options={schoolStaffs?.map(staff => ({value: staff.staffId, label: staff.name})) || []}
                            value={interviewFormState?.responsibles}
                            onChange={(selectedOptions) => setInterviewFormState({...interviewFormState, responsibles: selectedOptions})}
                            required
                            isMulti
                        />
                    </div>
                    <div className='my-3'>
                        <Form.Label>{t("selection.interviewType")}</Form.Label>
                        <Select
                            className="select"
                            name='interviewType'
                            options={[{value: "Online", label: t("selection.Online")}, {value: "FaceToFace", label: t("selection.FaceToFace")}]}
                            value={interviewFormState?.type}
                            onChange={(value) => setInterviewFormState({...interviewFormState, type: value})}
                            required
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-0 p-4'>
                    <Button variant="secondary" onClick={() => setInterviewFormState(null)}>
                        {t('global.cancel')}
                    </Button>
                    <Button variant="primary" onClick={handleInterviewActions}>
                        {t('global.save')}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={publishModal} onHide={() => setPublishModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('selection.publish')}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={submit} className='light-input'>
                    <Modal.Body>
                        <div className='my-3'>
                            <Form.Label>{t("selection.startDate")}</Form.Label>
                            <Form.Select
                                name='startDateNow'
                                className='p-3'
                                value={startDateNow || 'false'}
                                onChange={handleStartDateChange}
                                required
                            >
                                <option value={new Date().toISOString().split('T')[0]}>{t('selection.now')}</option>
                                <option value={"false"}>{t('selection.selectDate')}</option>
                            </Form.Select>
                        </div>
                        {
                            startDateNow === "false"
                            ?
                                <div className='my-3'>
                                    <Form.Label>{t("selection.startDate")}</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name='startDate'
                                        value={state.startDate || ''}
                                        onChange={handleInputChange}
                                        required
                                        min={new Date().toISOString().split('T')[0]}
                                        max={new Date(state?.incorporationDate || new Date()).toISOString().split('T')[0]}
                                    />
                                    {
                                        new Date(state?.incorporationDate) < new Date()
                                        ?
                                            <span className='text-danger'>{t('selection.wrongIncorporationDate')}</span>
                                        :
                                            <></>
                                    }
                                </div>
                            :
                                <></>
                        }
                        <div className='my-3'>
                            <Form.Label className="me-2 mt-2 mb-1" htmlFor="substitution">{t('selection.showInLandingPage')}</Form.Label>
                            <div className='d-lg-flex align-items-center'>
                                <span className='text-muted me-2'>{t("global.no")}</span>
                                <Form.Check
                                    type="switch"
                                    name="showInLandingPage"
                                    onChange={(e) => handleSwitchChange(e.target.checked, 'showInLandingPage')}
                                    checked={state.showInLandingPage === true}
                                    disabled={state.started === true && !isAdmin}
                                />
                                <span className='text-muted ms-2'>{t("global.yes")}</span>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setPublishModal(false)}>
                            {t('global.cancel')}
                        </Button>
                        <Button variant="primary" onClick={handlePublish}>
                            {t('global.publish')}
                        </Button>
                        <button type='submit' hidden className='d-none' ref={submitBtnRef}/>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

function CustomAccordion({children, eventKey}) {
    const handleCick = useAccordionButton(eventKey, () => {})

    return (
        <div className='data color-primary cursor text-decoration-underline' onClick={handleCick}>{children}</div>
    )
}